import { BrowserRouter, Routes, Route } from "react-router-dom"
import { useEffect, useState } from "react"
import _Main from "./pages/_Main"
import Admin from "./pages/admin/Admin"
import AdminTeams from "./pages/admin/AdminTeams"
import AdminUsers from "./pages/admin/AdminUsers"
import Team from "./pages/team/Team"
import TeamMembers from "./pages/team/TeamMembers"
import TeamPermissions from "./pages/team/TeamPermissions"
import TeamSettings from "./pages/team/TeamSettings"
import Login from "./pages/Login"
import Register from "./pages/Register"
import Welcome from "./pages/Welcome"
import Widgets from "./pages/widgets/Widgets"
import AddWidgets from "./pages/widgets/AddWidgets"
import BidScanner from "./pages/widgets/BidScanner"
import ScheduleExtractor from "./pages/widgets/ScheduleExtractor"
import ProductFinder from "./pages/widgets/ProductFinder"
import WallHeightCalculator from "./pages/widgets/WallHeightCalculator"
import IrrigationAuditor from "./pages/widgets/IrrigationAuditor"
import ResetPassword from "./pages/ResetPassword"
import NotFound from "./pages/NotFound"

// TODO: look into using dynamic routing (this needs more work)
// function AppRouter({ basename }) {
//   return (<BrowserRouter basename={`/${basename}`}>
//     <Routes>
//       <Route path="/" element={<_Main />}/>
//       <Route path="/login" element={<Login />}/>
//       <Route path="/reset-password" element={<ResetPassword />}/>
//       {/* <Route path="/register" element={<Register />}/> */}
//       <Route path="/welcome" element={<Welcome />}/>

//       <Route path="/admin">
//         <Route index element={<Admin />}/>
//         <Route path="teams" element={<AdminTeams />}/>
//         <Route path="users" element={<AdminUsers />}/>
//       </Route>
      
//       <Route path="/team">
//         <Route index element={<Team />}/>
//         <Route path="members" element={<TeamMembers />}/>
//         <Route path="permissions" element={<TeamPermissions />}/>
//         <Route path="settings" element={<TeamSettings />}/>
//       </Route>
      
//       {/* <Route path="/widgets">
//         <Route index element={<Widgets />}/> */}
//         <Route path="/widgets" element={<Widgets />}/>
//         <Route path="/bid-scanner" element={<BidScanner />}/>
//         <Route path="/product-finder" element={<ProductFinder />}/>
//         <Route path="/schedule-extractor" element={<ScheduleExtractor />}/>
//         <Route path="/wall-height-calculator" element={<WallHeightCalculator />}/>
//         <Route path="/irrigation-auditor" element={<IrrigationAuditor />}/>
//       {/* </Route> */}
//       <Route path="/add-widgets" element={<AddWidgets />}/>

//       <Route path="*" element={<NotFound />}/>
//     </Routes>
//   </BrowserRouter>);
// }

// export default function App() {
//   const [basename, setBasename] = useState(window.location.pathname.split('/')[1]);

//   useEffect(() => {
//     setBasename(window.location.pathname.split('/')[1]);
//     console.log(basename)
//   }, [window.location.pathname]);

//   return (<AppRouter basename={basename} />);
// }



export default function App() {
  const selectedTheme = localStorage.getItem('theme')
  if (selectedTheme) {
    document.querySelector('body').setAttribute('data-theme', selectedTheme)
  }

  return (<div id="app">
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<_Main />}/>
        <Route path="/login" element={<Login />}/>
        <Route path="/reset-password" element={<ResetPassword />}/>
        {/* <Route path="/register" element={<Register />}/> */}
        <Route path="/welcome" element={<Welcome />}/>

        {/* <Route path="/admin"> */}
          {/* <Route index element={<Admin />}/> */}
          <Route path="/admin" element={<Admin />}/>
          <Route path="/teams" element={<AdminTeams />}/>
          <Route path="/users" element={<AdminUsers />}/>
        {/* </Route> */}
        
        {/* <Route path="/team"> */}
          {/* <Route index element={<Team />}/> */}
          <Route path="/team" element={<Team />}/>
          <Route path="/members" element={<TeamMembers />}/>
          <Route path="/permissions" element={<TeamPermissions />}/>
          <Route path="/settings" element={<TeamSettings />}/>
        {/* </Route> */}
        
        {/* <Route path="/widgets"> */}
          {/* <Route index element={<Widgets />}/> */}
          <Route path="/widgets" element={<Widgets />}/>
          <Route path="/bid-scanner" element={<BidScanner />}/>
          <Route path="/product-finder" element={<ProductFinder />}/>
          <Route path="/schedule-extractor" element={<ScheduleExtractor />}/>
          <Route path="/wall-height-calculator" element={<WallHeightCalculator />}/>
          <Route path="/irrigation-auditor" element={<IrrigationAuditor />}/>
        {/* </Route> */}
        <Route path="/add-widgets" element={<AddWidgets />}/>

        <Route path="*" element={<NotFound />}/>
      </Routes>
    </BrowserRouter>
  </div>)
}
